"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DataTable_1 = require("./DataTable");
exports.default = DataTable_1.default;
//# sourceMappingURL=index.js.map